export default __webpack_public_path__ + "static/media/1-100.a953c1d3.jpg";